import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  FormBuilder,
  FormGroup,
  Validators,
  ReactiveFormsModule,
} from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../../services/auth/auth.service';

@Component({
  selector: 'app-reset-password',
  standalone: true,
  imports: [CommonModule, RouterModule, ReactiveFormsModule],
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css'],
})
export class ResetPasswordComponent {
  resetPasswordForm: FormGroup;
  showNewPassword = false;
  showConfirmPassword = false;
  identifier: string = '';
  identifierType: 'email' | 'mobile_number' = 'email';

  constructor(
    private fb: FormBuilder,
    private toastr: ToastrService,
    private router: Router,
    private authService: AuthService,
  ) {
    this.resetPasswordForm = this.fb.group({
      newPassword: ['', [Validators.required, Validators.minLength(6)]],
      confirmPassword: ['', [Validators.required, Validators.minLength(6)]],
    });

    const identifierFromStorage =
      localStorage.getItem('forgot_password_identifier') ||
      localStorage.getItem('email');
    const identifierTypeFromStorage =
      localStorage.getItem('forgot_password_identifier_type') || 'email';

    if (identifierFromStorage) {
      this.identifier = identifierFromStorage;
      this.identifierType =
        identifierTypeFromStorage === 'mobile_number'
          ? 'mobile_number'
          : 'email';
    } else {
      this.toastr.error('Contact details not found. Please try again.', 'Error');
      this.router.navigate(['/forgot-password']);
    }
  }

  toggleNewPassword(): void {
    this.showNewPassword = !this.showNewPassword;
  }

  toggleConfirmPassword(): void {
    this.showConfirmPassword = !this.showConfirmPassword;
  }

  onSubmit(): void {
    if (this.resetPasswordForm.valid) {
      const { newPassword, confirmPassword } = this.resetPasswordForm.value;

      if (newPassword !== confirmPassword) {
        this.toastr.error('Passwords do not match!', 'Error');
        return;
      }

      this.authService
        .resetPassword(
          this.identifier,
          newPassword,
          confirmPassword,
          this.identifierType,
        )
        .subscribe({
          next: (response) => {
            if (response.status === 'Operation successful') {
              this.toastr.success(
                'Password reset successfully! Please login to your account.',
                'Success',
              );
              localStorage.removeItem('email');
              localStorage.removeItem('forgot_password_identifier');
              localStorage.removeItem('forgot_password_identifier_type');
              localStorage.removeItem('forgot_password_mobile_number');
              this.router.navigate(['/login']);
            }
          },
          error: (error) => {
            this.toastr.error(
              'Failed to reset password. Please try again.',
              'Error',
            );
          },
        });
    }
  }
}
